import React from 'react';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';

export default function GuardLogScreen({ route }) {
  const { communityId } = route.params ?? {};

  return (
    <View style={tw`flex-1 bg-white`}>
      <SafeAreaView style={tw`flex-1 items-center justify-center`}>
        <Text style={tw`text-xl text-gray-500`}>Bitácora</Text>
        <Text style={tw`text-gray-400 mt-2`}>Próximamente</Text>
      </SafeAreaView>
    </View>
  );
}
